import { sendFeedback } from '@sentry/browser';

// Annotated via the imported binding: inferred, the declaration build names the
// type by its declaring package (@sentry/core), which we do not depend on.
export const submitUserFeedback: typeof sendFeedback = sendFeedback;
